import { MultipleChoiceSpoergsmaal } from './MultipleChoiceSpoergsmaal';
import { MultipleChoiceSvar } from './MultipleChoiceSvar'; 
export class MultipleChoiceBesvarelse {
        public spoergsmaalList: MultipleChoiceSpoergsmaal[];
        public svarList: MultipleChoiceSvar[];
        public antalSpoergsmaal: number;
        public alleSpoergsmaalBesvaret: boolean;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/MultipleChoiceBesvarelse.ts